<template>
    <div class="columns is-multiline d-flex flex-column flex-md-row">
        <section class="sidebar column is-full-mobile is-4-tablet is-3-desktop">
            <cat-uxo-call-to-action class="mb-4 shape--top"></cat-uxo-call-to-action>
            <a class="btn w-100 mb-4" href="/contribute">Contribute a New Hazard</a>
            <cat-uxo-stacked-ads></cat-uxo-stacked-ads>
        </section>
        <section class="uxo-type column is-offset-1-desktop is-8 p-0">
            <template v-if="!loading">
                <div class="flex w-full flex-col space-y-4">
                    <div class="flex">
                        <h1 class="h2 font-weight-normal t-black">Search</h1>
                    </div>
                    <div class="flex w-full">
                        <form action="/search" class="form form-search d-flex justify-content-center w-full">
                            <div class="field position-relative w-100">
                                <div class="control">
                                    <input class="input w-100 rounded-xl" name="query" type="text" :value="query" placeholder="E.g. Type 58 Landmine"/>
                                </div>
                                <div class="control">
                                    <button class="btn btn-search !rounded-tr-xl !rounded-br-xl"></button>
                                </div>
                            </div>
                        </form>
                    </div>

                    <template v-if="search">
                        <template v-for="i in Object.keys(search)">
                            <div v-if="search[i].length" class="flex cap flex-col border rounded-xl bg-white p-1">
                                <div class="flex justify-between bg-[#143642] p-1 px-2 w-full rounded-[9px]">
                                    <div class=" capitalize text-white text-sm font-medium">
                                        {{ i.replace('_', ' ') }}
                                    </div>
                                </div>
                                <div class="flex flex-col space-y-4 p-2">
                                    <template v-for="record in search[i]">
                                        <a :href="record.permalink" class="flex group w-full justify-between cursor-pointer">
                                            <div class="flex pr-4 space-x-4 w-full">
                                                <div class="w-10 h-10 flex">
                                                    <img class="my-auto w-10 object-fit" :src="record.image"/>
                                                </div>
                                                <div class="my-auto text-sm font-medium group-hover:text-[#E57722]">{{ record.name }}</div>
                                            </div>
                                            <svg class="fill-current my-auto text-[#E57722] w-2.5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                                                <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                                                <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/>
                                            </svg>
                                        </a>
                                    </template>
                                </div>
                            </div>
                        </template>
                    </template>


                    <div v-if="!Object.values(this.search).some(value => {
                    return Array.isArray(value) && value.length > 0;
                })">
                        <div class="font-medium text-[#143642]">No results found matching your search query.</div>
                    </div>

                </div>
            </template>
            <template v-else>
                <div class="w-full h-full flex">
                    <div role="status" class="mx-auto flex flex-col mt-20">
                        <svg aria-hidden="true" class="inline mx-auto w-14 h-14 text-[#143642] animate-spin fill-[#E57722]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor"/>
                            <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentFill"/>
                        </svg>
                        <div class="font-medium text-[#143642] mt-4">Searching CAT-UXO database...</div>
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </template>
        </section>
    </div>
</template>

<script>
import {ContentLoader} from 'vue-content-loader'
import StackedAds from "../shared/StackedAds";
import {axiosPlatform} from "@/js/axios";

export default {
    components: {
        ContentLoader,
        StackedAds,
    },
    props: {
        query: {
            type: String,
            required: true
        }
    },
    data: function () {
        return {
            loading: true,
            search: null
        }
    },
    computed: {},
    methods: {},
    async created() {

    },
    async mounted() {
        this.search = (await axiosPlatform.get(`/search?query=${this.query}`)).data
        this.loading = false
    }
}
</script>

<style scoped lang="scss">
.content-loader {
    min-height: rem(200px);

    @include media-breakpoint-up(sm) {
        min-height: rem(300px);
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/pages/PlatformSearch.vue